import React from "react";
import styles from "./orderProductDetails.module.scss";
import productImage from "../../../assets/images/productImg.jpg";
import { connect } from "react-redux";

const OrderProductDetails = ({ product = {} }) => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>Product Details</div>

      <div className={styles.details}>
        <div className={styles.imgContainer}>
          <div className={styles.imageWrapper}>
            <img
              src={product?.imageUrl}
              alt="Product"
              className={styles.productImage}
            />
          </div>
        </div>

        <div className={styles.detailsWrapper}>
          <div className={styles.left}>
            <div className={styles.row}>
              <div className={styles.label}>Product Name</div>
              <div className={styles.value}>: {product?.name}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>Instock quantity:</div>
              <div className={styles.value}>: {product?.quantity}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>Weight</div>
              <div className={styles.value}>: {product?.weight}{product?.siUnit}</div>
            </div>
          </div>
          {/* <div className={styles.right}>
          <div className={styles.row}>
            <div className={styles.label}>Price</div>
            <div className={styles.value}>: ₹{product?.price}</div>
          </div>

          <div className={styles.row}>
            <div className={styles.label}>Weight</div>
            <div className={styles.value}>: {product?.weight}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>Quantity</div>
            <div className={styles.value}>: {product?.quantity}</div>
          </div>

          <div className={styles.row}>
            <div className={styles.label}>SKU</div>
            <div className={styles.value}>: {product?.skuId}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>Keywords</div>
            <div className={styles.value}>: {product?.keywords}</div>
          </div>
        </div> */}
        </div>
      </div>
      {/* 
      <div className={styles.descriptionWrapper}>
        <div className={styles.descriptionTitle}>DETAILED DESCRIPTION</div>
        <div className={styles.descriptionSubtitle}>Rorem Ipsum Dolor</div>
        <div className={styles.descriptionText}>
          Indulge in the pure, creamy goodness of Itambé Natural Goat Milk,
          sourced from grass-fed goats raised in serene highland pastures. Our
          milk is gently pasteurized to preserve its rich nutrients and natural
          flavor—perfect for those seeking a wholesome alternative to cow’s
          milk. Whether enjoyed chilled, frothed in your morning coffee, or
          poured over your favorite cereal, every sip offers a smooth, subtly
          sweet taste with a hint of earthy freshness.
        </div>
        <div className={styles.descriptionPoint}>100% natural</div>
        <div className={styles.descriptionPoint}>
          High in calcium and protein
        </div>
        <div className={styles.descriptionPoint}>
          Lactose-friendly and easy to digest
        </div>
      </div> */}
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    product: state?.product?.product,
  };
};

export default connect(mapStateToProps, null)(OrderProductDetails);
